import { render, staticRenderFns } from "./OrcamentoItensTabela.vue?vue&type=template&id=602c6bca&scoped=true"
import script from "./OrcamentoItensTabela.vue?vue&type=script&lang=js"
export * from "./OrcamentoItensTabela.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoItensTabela.vue?vue&type=style&index=0&id=602c6bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602c6bca",
  null
  
)

export default component.exports